module.exports = __webpack_public_path__ + "img/technician.93757f9d.jpg";